<div class="card">
  <div class="card-header">
    {{ title }}
  </div>
  <div class="card-body">
    <ng-content></ng-content>
  </div>
</div>
